import { useSelector } from 'react-redux'
import { GetPrimaryColorHex } from 'redux/slices/brand'
import SpinnerWhite from 'media/icons/spinner-white.png'

export default function BrandColorButton({
    size = 'small',
    text = 'Button Text',
    action = () => { console.log('Add a button action') },
    isLoading = false,
    className = '',
}) {

    const styleConfig = useSelector((state) => state.brand.styleConfig)

    return (
        <div> {/* Need this to make sure buttons do not get squished in flex-col */}
            <button 
                className={`
                    hover:opacity-90
                    ${size === 'large' ? 'w-full h-14 flex items-center justify-center gap-x-4 rounded-2xl text-lg text-white' : ''}
                    ${size === 'small' ? 'w-full h-10 flex items-center justify-center gap-x-2 rounded-2xl text-sm text-white' : ''}
                    ${size === 'extra-small' ? 'w-full h-8 flex items-center justify-center gap-x-2 rounded-xl text-xs text-white' : ''}
                    ${className}
                `}
                style={{ 
                    backgroundColor: GetPrimaryColorHex(styleConfig),
                    WebkitTapHighlightColor: 'transparent',
                    WebkitTouchCallout: 'none',
                    WebkitUserSelect: 'none',
                    userSelect: 'none',
                    outline: 'none'
                }}
                onClick={action} 
                disabled={isLoading}
                onFocus={(e) => e.target.style.outline = 'none'}
                onBlur={(e) => e.target.style.outline = 'none'}
            >
                {!isLoading && (
                    <>
                        {text}
                    </>
                )}

                {isLoading && (
                    <>
                        Loading
                        <img 
                            src={SpinnerWhite} 
                            alt="Spinner" 
                            className={`
                                ${size === 'large' ? 'animate-spin h-4 w-4' : ''}
                                ${size === 'small' ? 'animate-spin h-3 w-3' : ''}
                                ${size === 'extra-small' ? 'animate-spin h-3 w-3' : ''}
                            `}
                        />
                    </>
                )}
            </button>
        </div>
    )
}
